import {
  CareResourcesArticleLinkFragment,
  CareResourcesOtherLinkFragment,
  CareResourcesProductFragment,
} from 'projects/sharedComponents/src/generated/contentful-graphql-types';

import { CareResourcesArticleLink } from 'projects/sharedComponents/src/pet/careResources/links/careResourcesArticleLink';
import { CareResourcesOtherLink } from 'projects/sharedComponents/src/pet/careResources/links/careResourcesOtherLink';
import { CareResourcesProduct } from 'projects/sharedComponents/src/pet/careResources/products/careResourcesProduct';
import { FC } from 'react';
import { PersonalizedVariableContentFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';

export type CareResourcesSectionCarouselItemProps = {
  pet: PersonalizedVariableContentFragment;
  item: CareResourcesArticleLinkFragment | CareResourcesProductFragment | CareResourcesOtherLinkFragment | null;
  reasonId?: string;
  useReactRouterLink?: boolean;
  index: number;
};

export const CareResourcesSectionCarouselItem: FC<CareResourcesSectionCarouselItemProps> = ({
  item,
  pet,
  reasonId,
  index,
  useReactRouterLink = true,
}) => {
  if (!item?.__typename) {
    return null;
  }

  if (item.__typename === 'CareResourcesProduct') {
    return <CareResourcesProduct product={item} pet={pet} heapValue={index} />;
  }

  if (item.__typename === 'ArticlePage') {
    return (
      <CareResourcesArticleLink
        article={item}
        pet={pet}
        reasonId={reasonId ?? ''}
        heapValue={index}
        useReactRouterLink={useReactRouterLink}
      />
    );
  }

  if (item.__typename === 'CareResourcesLink') {
    return <CareResourcesOtherLink link={item} pet={pet} heapValue={index} />;
  }

  return null;
};
